export type JackpotCoinTier = 'grand' | 'major' | 'minor' | 'mini'

/**
 * Jackpot tier carried by a coin's `coinType`, or null for an ordinary prize coin.
 *
 * A coin is a jackpot coin purely by its type string — `symbolKey` does not distinguish
 * them, so anything gating on `symbolKey === 'k'` will not separate the two.
 *
 * Check order mirrors BonusRespinBoardContainer.resolveJackpotTier so the reels, the board
 * and the sound layer all bucket a given coinType identically.
 */
export const resolveJackpotCoinTier = (coinType: unknown): JackpotCoinTier | null => {
    const normalized = String(coinType || '').toLowerCase()

    if (normalized.includes('grand')) {
        return 'grand'
    }

    if (normalized.includes('major')) {
        return 'major'
    }

    if (normalized.includes('minor')) {
        return 'minor'
    }

    if (normalized.includes('mini')) {
        return 'mini'
    }

    return null
}
